"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Values = exports.TotalPrice = exports.TotalBp = exports.SecondLine = exports.Root = exports.QuantityInfo = exports.ProductName = exports.PriceWrapper = exports.OriginalPrice = exports.MobileWrapper = exports.ItemPrice = exports.ImageWrapper = exports.DetailValues = exports.Detail = exports.DesktopWrapper = void 0;
var _mui = require("@ori-ui/mui");
const ellipsisStyles = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis'
};
const Root = exports.Root = (0, _mui.styled)('div')(({
  ownerState: {
    isVisibleBundle
  },
  theme
}) => ({
  background: theme.palette.common.white,
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
  width: '100%',
  maxWidth: 680,
  padding: theme.spacing(3, 0),
  justifyContent: 'flex-end',
  ...(!isVisibleBundle && {
    borderBottom: `1px solid ${theme.palette.grey[100]}`
  })
}));
const ImageWrapper = exports.ImageWrapper = (0, _mui.styled)('div')(({
  ownerState: {
    isVisibleBundle
  },
  theme
}) => ({
  background: theme.palette.grey[100],
  alignItems: 'center',
  display: 'flex',
  width: '80px',
  height: '110px',
  borderRadius: theme.spacing(1),
  ...(isVisibleBundle && {
    boxShadow: theme.shadows[4]
  })
}));
const DetailValues = exports.DetailValues = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flex: '1',
  flexDirection: 'column',
  overflow: 'hidden',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row'
  }
}));
const Detail = exports.Detail = (0, _mui.styled)('div')(({
  theme
}) => ({
  background: theme.palette.common.white,
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  position: 'relative',
  [theme.breakpoints.up('md')]: {
    maxWidth: '29%'
  }
}));
const SecondLine = exports.SecondLine = (0, _mui.styled)('div')({
  display: 'flex',
  flexDirection: 'row',
  maxWidth: 'calc(100% - 80px)'
});
const Values = exports.Values = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  marginTop: 'auto',
  position: 'relative',
  bottom: 0,
  left: 0,
  width: '100%',
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    flexGrow: 1,
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'flex-end',
    maxWidth: '71%',
    marginTop: 'initial',
    position: 'relative'
  }
}));
const QuantityInfo = exports.QuantityInfo = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  alignSelf: 'flex-end',
  display: 'flex',
  position: 'relative',
  width: 90,
  [theme.breakpoints.up('md')]: {
    alignSelf: 'center',
    flexShrink: 0,
    justifyContent: 'center'
  }
}));
const MobileWrapper = exports.MobileWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  [theme.breakpoints.up('md')]: {
    display: 'none'
  }
}));
const DesktopWrapper = exports.DesktopWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    display: 'none'
  }
}));
const OriginalPrice = exports.OriginalPrice = (0, _mui.styled)(_mui.Typography)({
  textDecoration: 'line-through'
});
const TotalPrice = exports.TotalPrice = (0, _mui.styled)(_mui.Typography)({
  fontWeight: 'bold'
});
const TotalBp = exports.TotalBp = (0, _mui.styled)(_mui.Typography)({
  width: 90,
  textAlign: 'center'
});
const PriceWrapper = exports.PriceWrapper = (0, _mui.styled)('div')(({
  ownerState: {
    isOriginalPriceEmpty
  }
}) => ({
  display: 'flex',
  flexDirection: 'column',
  width: 125,
  alignItems: 'center',
  ...(!isOriginalPriceEmpty && {
    height: '63px'
  })
}));
const ItemPrice = exports.ItemPrice = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  width: 110,
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    display: 'none'
  }
}));
const ProductName = exports.ProductName = (0, _mui.styled)(_mui.Typography)({
  ...ellipsisStyles
});
